import { Modal } from "bootstrap";

export async function hideModal(idModal) {
  let modalId = document.getElementById(idModal);
  const modal = Modal.getInstance(modalId);
  modal.hide();
}
